export default __webpack_public_path__ + "static/media/logo-somabcn.aa1ea639.svg";